module.exports = __webpack_public_path__ + "static/media/spear-phishing-2.698fc1ca.png";